module.exports = __webpack_public_path__ + "dac92268001142ee716928bfa62adc50.png";